import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from './SlidesCompare.module.scss';
import PathContext from '../../context/path';
import StateContext from '../../context/state';
const SlidesCompare = () => {
	const path = useContext(PathContext);
	const state = useContext(StateContext);
	const { updateAllStages, stage, transition } =
		state;
	const refSlides = useRef(null);
	const [currentStage, setCurrentStage] = useState(-1);
	const [reverse, setReverse] = useState(false);
	useEffect(() => {
		const slides = refSlides.current.children;
		let countArray = [];
		let counter = 0;
		for (const child of slides) {
			if (!child.classList.contains(styles.slide_mobile)) {
				child.dataset.slide = counter;
				countArray.push(child);
				counter++;
			}
		}
		updateAllStages(countArray.length);
	}, [updateAllStages]);

	useEffect(() => {
		let diff = currentStage > stage;
		if (!transition && diff) {
			setReverse(true);
		} else {
			setReverse(false);
		}
	}, [currentStage, stage, transition]);
	useEffect(() => {
		let diff = currentStage - stage;
		let timer = null,
			prevTimer = null;
		if (diff !== 0) {
			const slides = Array.from(refSlides.current.children);
			const prevSlide = slides.filter((item) =>
				item.classList.contains(styles.active)
			);
			if (prevSlide[0] !== undefined) {
				prevTimer = setTimeout(() => {
					prevSlide[0].classList.remove(styles.active);
				}, 500);
				const orderList = prevSlide[0].querySelectorAll(
					'[data-animation-order]'
				);
				if (orderList.length > 0) {
					orderList.forEach((element) => {
						element.classList.remove(styles.shown);
					});
				}
			}
		}
		if (reverse && !transition) {
			setCurrentStage(stage);
		}
		if (diff < 0) {
			let time = 500;
			if(stage === 1){
				time = 4000;
			}
			timer = setTimeout(() => {
				setCurrentStage(stage);
				
			}, time);
		}
		return () => {
			// clearInterval(prevTimer);
			clearInterval(timer);
		};
	}, [stage, currentStage, reverse, transition]);

	useEffect(() => {
		const slides = Array.from(refSlides.current.children);
		const currentSlide = slides.filter(
			(item) => parseInt(item.dataset.slide, 10) === currentStage
		);
		if (currentSlide[0] !== undefined) {
			const orderList = currentSlide[0].querySelectorAll(
				'[data-animation-order]'
			);
			currentSlide[0].classList.add(styles.active);
			if (orderList.length > 0) {
				orderList.forEach((element) => {
					setTimeout(() => {
						element.classList.add(styles.shown);
					}, element.dataset.animationOrder * 150);
				});
			}
		}
		// console.log(currentStage);
	}, [currentStage]);

	return (
		<>
			<div className={styles.wrap} ref={refSlides}>
				<div className={`${styles.slide} ${styles.slide_0}`}>
					<div className={styles.container}>
						<h1 className={styles.h1} data-animation-order={0}>
							<span>Какой </span>
							<span>способ </span>
							<span>перевозки </span>
							<span>лучше</span>
						</h1>
						<div className={styles.text} data-animation-order={1}>
							<span>Море, </span>
							<span>авиа </span>
							<span>или железная </span>
							<span>дорога — </span>
							<span>какая </span>
							<span>модальность </span>
							<span>больше </span>
							<span>подходит </span>
							<span>для транспортировки </span>
							<span>на большие </span>
							<span>расстояния?</span>
						</div>
						<div className={styles.text} data-animation-order={1}>
							<span>Отправьте </span>
							<span>контейнеры </span>
							<span>с грузом </span>
							<span>по транзитным </span>
							<span>маршрутам </span>
							<span>разными </span>
							<span>видами </span>
							<span>транспорта </span>
							<span>и найдите </span>
							<span>вариант </span>
							<span>с идеальным </span>
							<span>соотношением </span>
							<span>цены, </span>
							<span>скорости </span>
							<span>и экологичности</span>
						</div>
						<div className={styles.btn} data-animation-order={2}>
							<img src={`${path}/img/icon-hand.svg`} alt='' />
						</div>
					</div>
				</div>

				{/* <div className={`${styles.slide}`}>

				</div> */}

				<div className={`${styles.slide} ${styles.slide_2}`}>
					<div className={styles.container}>
						<div className={styles.card} data-animation-order={0}>
							<div className={styles.desc}>СамолЁт Первым доставит груз</div>
							<h4 className={styles.h4}>Авиа: быстро, но дорого</h4>
							<div className={styles.text}>Авиаперевозки действительно самый быстрый, но и самый дорогой вид транспорта.</div>
							<div className={styles.text}>Эту модальность чаще используют для перевозки скоропортящихся, дорогостоящих грузов или товаров быстрого потребления. <br /> Также авиатранспорт востребован при перевозках в труднодоступные регионы</div>
						</div>
					</div>
				</div>
				<div className={`${styles.slide} ${styles.slide_3}`}>
					<div className={styles.container}>
						<div className={styles.card} data-animation-order={0}>
							<div className={styles.desc}>Поезд окажется на финише вторым</div>
							<h4 className={styles.h4}>Железная дорога: быстро, надёжно, экологично</h4>
							<div className={styles.text}>Помимо высокой скорости, перевозки по железной дороге отличает стабильность и безопасность. Среди всех видов грузового транспорта железнодорожный является самым экологичным</div>
						</div>
					</div>
				</div>
				<div className={`${styles.slide} ${styles.slide_4}`}>
					<div className={styles.container}>
						<div className={styles.card} data-animation-order={0}>
							<div className={styles.desc}>Корабль прибудет последним</div>
							<h4 className={styles.h4}>Море: недорого, но долго</h4>
							<div className={styles.text}>Перевозки морем выгодно отличает большая вместимость судов, однако они остаются самыми медленными из всех модальностей.</div>
							<div className={styles.text}>Средства, потраченные на закупку товара, замораживаются на более долгий срок, из-за чего перевозка фактически может оказаться дороже железнодорожной</div>
						</div>
					</div>
				</div>
				<div className={`${styles.slide} ${styles.slide_5}`}>
					<div className={styles.container}>
						<h2 className={styles.h2} data-animation-order={0}><span>Результаты</span></h2>
						<div className={styles.table}>
							<div className={styles.table__row} data-animation-order={1}>
								<div className={styles.table__col}></div>
								<div className={styles.table__col}>Стоимость</div>
								<div className={styles.table__col}>Время в пути</div>
								<div className={styles.table__col}>Выбросы CO<sup>2</sup> <sup className={styles.star}>*</sup></div>
							</div>
							<div className={styles.table__row} data-animation-order={2}>
								<div className={styles.table__col}>Авиаперевозки</div>
								<div className={styles.table__col}><span className={styles.hidden}>Стоимость</span><span className={styles.red}>6,0</span></div>
								<div className={styles.table__col}><span className={styles.hidden}>Время в пути</span>0,6</div>
								<div className={styles.table__col}><span className={styles.hidden}>Выбросы CO<sup>2</sup> <sup className={styles.star}>*</sup></span><span className={styles.red}>527,7</span></div>
							</div>
							<div className={styles.table__row} data-animation-order={3}>
								<div className={styles.table__col}>Ж/д транспорт</div>
								<div className={styles.table__col}><span className={styles.hidden}>Стоимость</span>1,0</div>
								<div className={styles.table__col}><span className={styles.hidden}>Время в пути</span>1,0</div>
								<div className={styles.table__col}><span className={styles.hidden}>Выбросы CO<sup>2</sup> <sup className={styles.star}>*</sup></span>1,0</div>
							</div>
							<div className={styles.table__row} data-animation-order={4}>
								<div className={styles.table__col}>Морские перевозки</div>
								<div className={styles.table__col}><span className={styles.hidden}>Стоимость</span>0,8</div>
								<div className={styles.table__col}><span className={styles.hidden}>Время в пути</span><span className={styles.red}>4,5</span></div>
								<div className={styles.table__col}><span className={styles.hidden}>Выбросы CO<sup>2</sup> <sup className={styles.star}>*</sup></span>4,8</div>
							</div>
						</div>
						<div className={styles.description} data-animation-order={5}><span>Учитываются прямые выбросы CO<sup>2</sup> <br /> Все значения в таблице указаны в условных единицах</span></div>
					</div>
				</div>
				<div className={`${styles.slide} ${styles.slide_6}`}>
					<div className={styles.container}>
						<div className={styles.text} data-animation-order={0}>

							<span>При сравнении </span>
							<span>с другими видами </span>
							<span>грузоперевозок </span>
							<span>железные дороги </span>
							<span>показали оптимальное </span>
							<span>соотношение цены, </span>
							<span>скорости </span>
							<span>и экологичности</span>
						</div>
					</div>
				</div>
				<div className={`${styles.slide} ${styles.slide_7}`}>
					<div className={styles.container}>
						<h2 className={styles.h2} data-animation-order={0}>

							<span>Ваш </span>
							<span>следующий </span>
							<span>шаг</span>
						</h2>
						<div className={styles.text} data-animation-order={1}>

							<span>Возможно, </span>
							<span>вашей компании </span>
							<span>выгодно </span>
							<span>перейти </span>
							<span>на доставку </span>
							<span>по железной дороге? </span>
							<span>Консультант </span>
							<span>ОТЛК ЕРА </span>
							<span>подскажет, </span>
							<span>что выбрать</span>
						</div>
					</div>
				</div>

			</div>
		</>
	);
};

export default SlidesCompare;
